module.exports = __webpack_public_path__ + "static/media/5DPO15.f8e8d98e.jpg";